import * as React from "react";
import ContactTable from "./components/ContactTable";
import PageTitle from "../../global/components/PageTitle";
import {SnackbarProvider} from "notistack";

export default function Contacts() {

    return (
        <>
            <PageTitle title="Kontakte bearbeiten" />
            <SnackbarProvider>
                <ContactTable />
            </SnackbarProvider>
        </>

    )

}
